import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=06d7f6b0&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"
import style0 from "./Share.vue?vue&type=style&index=0&id=06d7f6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d7f6b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d7f6b0')) {
      api.createRecord('06d7f6b0', component.options)
    } else {
      api.reload('06d7f6b0', component.options)
    }
    module.hot.accept("./Share.vue?vue&type=template&id=06d7f6b0&scoped=true&", function () {
      api.rerender('06d7f6b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Media/Share.vue"
export default component.exports